// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bYvro","right":"styles_right__2C7JS"};